<template>
<svg viewBox="0 0 9 7">
<path fill="currentColor" d="M9,4.5c0,0.825-0.223,1.598-0.61,2.262C8.302,6.913,8.135,7,7.961,7H1.039C0.865,7,0.698,6.913,0.61,6.762
	C0.223,6.098,0,5.325,0,4.5C0,2.015,2.015,0,4.5,0S9,2.015,9,4.5z M5.5,5.5c0-0.552-0.448-1-1-1c-0.088,0-0.172,0.015-0.254,0.037
	L2.55,2.275C2.426,2.11,2.191,2.076,2.025,2.2C1.859,2.324,1.826,2.559,1.95,2.725l1.696,2.261C3.555,5.137,3.5,5.311,3.5,5.5
	c0,0.183,0.053,0.352,0.139,0.5h1.723C5.447,5.852,5.5,5.683,5.5,5.5z"/>
</svg>
</template>
